export default "__VITE_ASSET__BzgRfKzD__"